import Skeleton from "../ui/Skeleton";

export default function ButtonSkeleton() {
  return (
    <Skeleton
      css={{ rounded: "lg", width: "full", height: "3rem", flexShrink: "0" }}
    />
  );
}
